// A second opinion on "front or back?": taillights are red, headlights are
// not. Looks for bright red at the two ends of the car's box. A red car (or a
// sunset) makes it useless, so it then says nothing. Never decides alone; the
// walk only uses it to back up the brain. Pure; unit-tested.

export interface Rgba {
  data: Uint8ClampedArray | Uint8Array
  width: number
  height: number
}

export type EndHint = "rear" | null

function isLampRed(r: number, g: number, b: number): boolean {
  return r > 110 && r > g * 1.7 && r > b * 1.5
}

export function taillightHint(img: Rgba, box: { x: number; y: number; w: number; h: number }): EndHint {
  const { data, width, height } = img
  const x0 = Math.max(0, Math.floor(box.x * width))
  const x1 = Math.min(width, Math.ceil((box.x + box.w) * width))
  // The lamps sit in the middle band of the car's height.
  const y0 = Math.max(0, Math.floor((box.y + box.h * 0.2) * height))
  const y1 = Math.min(height, Math.ceil((box.y + box.h * 0.7) * height))
  const third = Math.max(1, Math.floor((x1 - x0) / 3))
  let ends = 0
  let endsRed = 0
  let middle = 0
  let middleRed = 0
  for (let y = y0; y < y1; y++) {
    for (let x = x0; x < x1; x++) {
      const i = (y * width + x) * 4
      const red = isLampRed(data[i], data[i + 1], data[i + 2])
      if (x < x0 + third || x >= x1 - third) {
        ends++
        if (red) endsRed++
      } else {
        middle++
        if (red) middleRed++
      }
    }
  }
  if (!ends || !middle) return null
  const endShare = endsRed / ends
  const middleShare = middleRed / middle
  // A red body: red everywhere, nothing to learn.
  if (middleShare > 0.08) return null
  return endShare > 0.012 && endShare > middleShare * 2.5 ? "rear" : null
}
